import { getheaders } from "./authService";

export async function getOauthUrl() {
    let requestOptions = {
        method: 'GET',
        headers: getheaders(),
        redirect: 'follow'
    };
    return fetch('/api/myob/oauth/url', requestOptions);
}

export async function getProfileList() {
    let requestOptions = {
        method: 'GET',
        headers: getheaders(),
        redirect: 'follow'
    };
    return fetch('/api/myob/profiles', requestOptions);
}

export async function getBusinessesAndAccounts(refresh) {
    let requestOptions = {
        method: 'GET',
        headers: getheaders(),
        redirect: 'follow'
    };
    return fetch(`/api/myob/businessesacounts?refresh=${refresh}`, requestOptions);
}

export async function updateAccountMapping(profileId, businessId, prop, value) {
    let body = {};
    body[prop] = { uid: value };
    let requestOptions = {
        method: 'PUT',
        headers: getheaders(),
        redirect: 'follow',
        body: JSON.stringify(body)
    };
    return fetch(`/api/myob/profiles/${profileId}/businessesacounts/${businessId}/accountsmapping`, requestOptions);
}

export async function deleteProfile(uid) {
    let requestOptions = {
        method: 'DELETE',
        headers: getheaders(),
        redirect: 'follow'
    };
    return fetch(`/api/myob/profile/${uid}`, requestOptions);
}
